import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { ConstructionProjectLoadModel, Sensor } from '@construction/models/construction-project.model';

/** Reads `project` from upstream state. Owns setters for sensors, Flytbase site ID, and NextPower ID. */
export function withSensors() {
  return signalStoreFeature(
    { state: type<{ project: ConstructionProjectLoadModel }>() },
    withMethods((store) => ({
      setConstructionProjectSensors(sensors: Sensor[]): void {
        patchState(store, { project: { ...store.project(), sensors } });
      },
      setConstructionProjectFlightbaseSiteId(siteId: string): void {
        patchState(store, { project: { ...store.project(), flytbase_site_id: siteId } });
      },
      setConstructionProjectNextPowerId(nextPowerId: string): void {
        patchState(store, {
          project: { ...store.project(), onsight_integration: { last_imported_at: null, project_id: nextPowerId } },
        });
      },
    })),
  );
}
